import moment from 'moment';
import {TerminalInstallationSelectors} from 'Redux/Selectors/TerminalInstallationSelectors';
import {store} from 'Redux/Store';
import i18n from '../../../../Translations/_i18n';


export class ValidatorsTerminalls {
    public static policyDateIsGreater = function(value,origin) {

        const technicianTemp = TerminalInstallationSelectors.getSelectedTechnician(store.getState());  

        if(value && origin.installationDate) {

            if(!technicianTemp) {
                return i18n.t('dictionary:policyConstraint');
            }

            if(!technicianTemp || !technicianTemp.insuranceEndDate || moment(technicianTemp.insuranceEndDate).set({ hours: 23, minutes: 59 }).isBefore(origin.installationDate)) {
                return i18n.t('dictionary:policyConstraint');
            } 
        }

        return undefined;      
    }
}



// WEBPACK FOOTER //
// ./src/components/Layout/Form/Fields/ValidatorsTerminalls.tsx